<script lang="ts">
	import { createEventDispatcher, onMount } from 'svelte';

	import type { Home } from 'src/types/Home';
	import HomeRow from '../Homes/HomeRow.svelte';
	import { currentUnitId, homes } from 'src/stores/account/home';
	import {
		pendingUnitTransfers,
		refreshPendingUnitTransfers,
	} from 'src/stores/account/pending_unit_transfers';
	import { Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	const dispatch = createEventDispatcher<{
		selectHome: Home;
	}>();

	onMount(() => {
		void refreshPendingUnitTransfers();
	});

	$: outgoingPendingUnitIds = new Set($pendingUnitTransfers.outgoing.map((t) => t.unit_id));
	$: switchableHomes = $homes.list.filter(
		(home) => home.id !== $currentUnitId && !outgoingPendingUnitIds.has(Number(home.id)),
	);
</script>

<div class="homelist-wrapper pt-s pb-m">
	<Text class="pb-s pl-s-plus" styleType="label-small"
		>{$format('button_switch_home', { default: 'Switch Home' })}</Text
	>
	<div class="homelist-items pl-s pr-s-plus">
		{#each switchableHomes as home}
			<HomeRow {home} isActive={false} on:select={(e) => dispatch('selectHome', e.detail)} />
		{/each}
	</div>
</div>

<style>
	.homelist-wrapper {
		background-color: var(--color-1);
		border-radius: var(--radius-big);
	}
</style>
